import { Card, CardContent, AppBar, Toolbar, Typography } from '@material-ui/core';
import { motion } from 'framer-motion';

// animation variant
const item = { hidden: { opacity: 0, y: 40 }, show: { opacity: 1, y: 0 } };

const CustomCard = ({ title, icon, children, contentClassName }) => {
  return (
    <>
      <Card
        component={motion.div}
        variants={item}
        initial="hidden"
        animate="show"
        className="w-full mb-32 rounded-16 shadow">
        <AppBar position="static" elevation={0} className="max-h-56">
          <Toolbar className="px-8">
            <Typography
              variant="subtitle1"
              color="inherit"
              className="flex-1 px-12 font-semibold tracking-wider ">
              {icon && <i className={`bx ${icon} bx-lg bx-fw pr-4`}></i>}
              {title}
            </Typography>
          </Toolbar>
        </AppBar>

        <CardContent className={contentClassName}>{children}</CardContent>
      </Card>
    </>
  );
};

CustomCard.defaultProps = {
  contentClassName: 'space-y-24 px-20'
};

export default CustomCard;
